import { makeVar } from '~/lazy_apollo/client';
import type { PopIconName } from '~/utils/pops';

export type PopCounts = Partial<Record<PopIconName | 'total' | 'wanna_try', Optional<number>>>;

export const userPopsVar = /* @__PURE__ */ makeVar<Record<string, PopCounts>>({});
